module.exports = __webpack_public_path__ + "88986e71e618635e75b54f22c58f4a93.pdf";